import React from 'react';

const TermsAndConditions = () => (
  <div style={{ padding: '2rem' }}>
    <h2>Terms and Conditions</h2>
    <p>By accessing this website or using our services, you agree to be bound by the following terms and conditions.</p>
    <p>We reserve the right to update these terms at any time without prior notice.</p>
    <p>Use of our services is subject to compliance with applicable laws and regulations.</p>
  </div>
);

export default TermsAndConditions;
